export const ZendeskConstants = {
  ZENDESK_SCRIPT_URL:
    'https://static.zdassets.com/ekr/snippet.js?key=2ba8c6cf-6eb8-408b-9a98-192838e14f59',
  ZENDESK_SCRIPT_ID: 'ze-snippet',
  ZD_MESSENGER_STYLE_ID: 'ft-zd-style',
};
